<template>
  <div class="right-box">
    <div v-for="item in content" :key="item.id" v-html="item.content"/>
    <div class="a-curtain" v-if="course && course.length > 0 && !title"></div>
    <div class="right-cont mg-pd-top0" v-if="course && course.length > 0">
      <div class="right-title" v-if="title"><h1><span class="s-l"></span>{{title}}<span class="s-r"></span></h1></div>
      <div class="right-txt">
        <h4 class="txt-title">{{config.ClassCname}}培训课程</h4>
        <div class="training-course">
          <div class="training-course-box" v-for="(item, key) in course" :key="key">
            <img :src="`https://img.233.com/wx/img/union/courseimg/20200225/${item.ClassEName}/${item.BzNum}.jpg`" onerror="this.src='https://img.233.com/wx/img/union/courseimg/20200225/default.jpg'">
            <h3>{{item.CourseName}}</h3>
            <div class="training-course-price">
              <span v-if="item.MinPrice === item.MaxPrice"><label>¥</label>{{item.MinPrice}}</span>
              <span v-else><label>¥</label>{{item.MinPrice}} - <label>¥</label>{{item.MaxPrice}}</span>
              <a :href="'/' + (isFine ? 'fine' : 'norm') + '/category/currency/#/?class=' + item.ClassEName" target="_blank">免费试听</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="title === '辅导老师' && teacher && Object.keys(teacher).length > 0">
      <div class="right-cont" v-if="teacher.teacherList.length > 0">
        <div class="right-title"><h1><span class="s-l"></span>{{title}}<span class="s-r"></span></h1></div>
        <div class="right-txt">
          <h4 class="txt-title">{{config.ClassCname}}辅导老师</h4>
          <div class="teacher-list">
            <div class="teacher-box" v-for="(item, key) in teacher.teacherList" :key="key" @click="toTeacherLink">
              <img :src="item.PicPath">
              <div class="teacher-info">
                <span>{{item.Name}}</span>
                <p>{{item.ShortCredentials}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="not-data" v-else>
        <i class="not-data-icon"></i>
        <p>暂无数据</p>
      </div>
    </template>
  </div>
</template>

<script>
import { GetContextById, GetCourse, GetFudaoCourse, GetFudaoTeacher } from "../../../lib/request"
export default {
  name: "Content",
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    isFine: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "",
      content: [],
      course: [],
      teacher: {}
    }
  },
  methods: {
    GetContextById(id) {
      GetContextById({ id }, (res) => {
        this.content = res.Result
      })
    },
    GetCourse(id) {
      GetCourse({ id }, (res) => {
        this.course = res.Result
      })
    },
    GetFudaoCourse(classId) {
      GetFudaoCourse({ classId }, (res) => {
        this.course = res.Result
      })
    },
    GetFudaoTeacher(classId) {
      GetFudaoTeacher({ classId }, (res) => {
        this.teacher = res.Result
      })
    },
    toTeacherLink() {
      window.open('/' + (this.isFine ? "fine" : "norm") + '/category/currency/#/?class=' + this.teacher.ClassEName)
    }
  }
}
</script>

<style lang="scss" scoped>
.right-box{
  /deep/.right-cont{
    margin-top: 0;
  }
  .a-curtain{
    width: 100%;
    height: 20px;
    margin-top: -10px;
    position: relative;
    background: #fff;
  }
  .mg-pd-top0{
    margin-top: 0;
    padding-top: 4px;
    .right-title{
      margin-top: 16px;
    }
  }
  .training-course{
    .training-course-box{
      display: inline-block;
      width: 31%;
      margin-right: 3%;
      margin-bottom: 24px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      img{
        width: 100%;
      }
      h3{
        color: #333;
        font-size: 16px;
        font-weight: 800;
        line-height: 16px;
        margin: 12px 0;
      }
      .training-course-price{
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
          font-size: 20px;
          color: #E13B29;
          font-weight: 400;
          label{
            font-size: 16px;
            margin-right: 3px;
          }
        }
        a{
          display: inline-block;
          height: 30px;
          line-height: 30px;
          background: linear-gradient(90deg, #F65336 0%, #F22523 100%);
          box-shadow: 0px 9px 10px 0px rgba(244, 53, 42, 0.11);
          border-radius: 15px;
          text-decoration: none;
          width: 95px;
          text-align: center;
          font-size: 14px;
          color: #fff;
        }
      }
    }
  }
  .teacher-list{
    .teacher-box{
      width: 31%;
      margin-right: 2%;
      position: relative;
      display: inline-block;
      margin-bottom: 24px;
      cursor: pointer;
      &:nth-child(3n){
        margin-right: 0;
      }
      img{
        width: 100%;
        vertical-align: top;
      }
      .teacher-info{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        background: rgba(0, 0, 0, .7);
        padding: 10px 20px;
        box-sizing: border-box;
        span{
          font-size: 18px;
          font-weight: 400;
          color: #fff;
          line-height: 20px;
        }
        p{
          font-size: 16px;
          font-weight: 400;
          color: #fff;
          text-indent: 0;
          line-height: 20px;
          margin-top: 6px;
        }
      }
    }
  }
  .not-data{
    background: #fff;
    padding: 20px 0 100px;
    .not-data-icon{
      width: 276px;
      height: 242px;
      background: url(https://img2.233.com/wx/union/pc/usercenter/img/default_icon.png) no-repeat -376px -341px;
      display: block;
      margin: 0px auto;
    }
    p{
      font-size: 16px;
      color: #aaa;
      text-align: center;
      position: relative;
      margin-top: 10px;
    }
  }
}
</style>